@import '../../stylesheets/defaults'

// Only the Panel form has a host, so the host rule sizes that form alone. The React form has no
// host, so the modal element carries the width itself. Both read one custom property, which
// inherits through the shadow boundary, so a callsite overriding `--mp-confirm-width` moves both.
:host
  position absolute
  width var(--mp-confirm-width, 400px)

+prefix-classes('mp-confirm-')
  // A class rather than the `mp-modal` tag: outside a shadow root this stylesheet is injected into
  // `document.head`, where a tag selector would resize every modal on the page.
  .modal
    width var(--mp-confirm-width, 400px)

  .container, .container *
    box-sizing border-box

  .container
    display flex
    flex-direction column

    .body
      display flex
      flex-direction row
      min-height 92px
      padding 24px 24px 0
      text-align left

      .body-content
        width 100%

        .description-newline
          white-space pre-line

          span
            display block
            padding-bottom 8px

    .buttons
      display flex
      justify-content flex-end
      padding 24px

      // Attribute form: `+prefix-classes` would rewrite a `.mp-button-root` class selector.
      [class~='mp-button-root']
        margin-left 8px

    .mp-input
      margin-top 12px
      width 100%

  .info-banner-bottom
    margin-top 16px
